import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2577412a")

_pushScopeId("data-v-2577412a")
const _hoisted_1 = { class: "entry-record" }
const _hoisted_2 = { class: "record-photo" }
const _hoisted_3 = { class: "record-msg" }
const _hoisted_4 = { class: "time" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _ctx.recordData.PicUrl,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click', _ctx.recordData.PicUrl)))
      }, null, 8, ["src"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("p", {
        class: "name",
        title: _ctx.recordData.Initiator
      }, _toDisplayString(_ctx.recordData.Initiator), 9, ["title"]),
      _createVNode("text", {
        class: "device",
        title: _ctx.recordData.Location
      }, _toDisplayString(_ctx.recordData.Location), 9, ["title"]),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.recordData.CaptureTime), 1)
    ])
  ]))
})